import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../utils/pickIf';

export const useStyles = makeStyles()(
  (
    theme,
    { height, checkedAsShippingAddress, isKiteUser, isListView } = {},
  ) => ({
    root: {
      backgroundColor: pickIf(checkedAsShippingAddress, '#F4F4F4', 'white'),
      borderRadius: 20,
      boxShadow: '0px 5px 15px rgba(44, 112, 172, 0.2)',
      height,
      padding: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        borderRadius: 10,
        padding: theme.spacing(1.5),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          borderRadius: 10,
          padding: theme.spacing(1.5),
        }),
      },
    },
    container: {
      height: '100%',
      overflow: 'hidden',
    },
    buttons: {
      display: 'flex',
      gap: theme.spacing(1),
      width: '100%',
      '& button': {
        backgroundColor: pickIf(checkedAsShippingAddress, 'white', '#F4F4F4'),
        borderRadius: 4,
        maxHeight: 24,
        minWidth: 24,
        padding: 4,
        '&:hover': {
          backgroundColor: pickIf(checkedAsShippingAddress, 'white', '#F4F4F4'),
        },
      },
    },
    fullAddress: {
      color: '#54565B',
      display: '-webkit-box',
      WebkitLineClamp: pickIf(isListView, 2, 3),
      WebkitBoxOrient: 'vertical',
      letterSpacing: pickIf(isKiteUser, '0.1px', 'initial'),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 14,
      lineHeight: pickIf(isKiteUser, '20px', '16px'),
      marginTop: theme.spacing(1),
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
        WebkitLineClamp: pickIf(isListView, 2, 5),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          WebkitLineClamp: pickIf(isListView, 2, 3),
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: 12,
        }),
      },
    },
    checkbox: {
      '& svg': {
        height: 22,
        width: 22,
      },
    },
    popper: {
      '& > div': {
        color: '#54565B',
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: '0.1px',
        maxWidth: pickIf(isKiteUser, 408, 384),
        textAlign: 'center',
      },
      [theme.breakpoints.down('md')]: {
        '& > div': {
          fontSize: 12,
          maxWidth: 206,
        },
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          '& > div': {
            fontSize: 12,
            maxWidth: 206,
          },
        }),
      },
    },
    warning: {
      cursor: 'pointer',
    },
    pinImg: {
      '& path': {
        stroke: pickIf(
          isKiteUser,
          theme.palette.primary1,
          theme.palette.primary2,
        ),
      },
    },
    mainPinImg: { '& path': { stroke: '#FFFFFF' } },
    mainAddress: {
      marginLeft: 'auto',
    },
    checkedMainAddress: {
      backgroundColor: `${theme.palette.primary1} !important`,
    },
    cartMainAddress: {
      color: theme.palette.primary1,
      '& path': {
        stroke: theme.palette.primary1,
      },
    },
  }),
);
